import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Icon element to render */
  children: ReactNode;
  /** Accessible label for screen readers */
  'aria-label': string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, className, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        // 32px square to match the standard button height. Literal px because the
        // app root is 13px, so rem `w-8/h-8` would resolve to 26px, not 32.
        'inline-flex items-center justify-center w-[32px] h-[32px] p-0 font-ds-sans text-inherit bg-transparent border border-transparent rounded-ds-sm cursor-pointer hover:bg-ds-grey-light disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
);

IconButton.displayName = 'IconButton';
